import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import Projects from "Projects";
export default store => {
  return {
    path: ":projectGroupType",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([import("./components")]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [Projects(store)],
  };
};
